<template>
  <section class="pickup-record-terms">
    <AppPageTitleBar title="Opći uvjeti" :back-to="returnRoute" back-label="Natrag na zapisnik" />

    <article class="page-panel pickup-record-terms__document">
      <h2 class="pickup-record-terms__title">OPĆI UVJETI KORIŠTENJA VOZILA IZ VOZNOG PARKA PORSCHE CROATIA d.o.o.</h2>

      <div class="grid grid-column-gap-24 grid-row-gap-24 pickup-record-terms__columns">
        <div class="col-12 col-md-6 grid-stack pickup-record-terms__column">
          <section>
            <h3>1. Općenito</h3>
            <p>Korisnik mora vozilo prije preuzimanja detaljno pregledati i provjeriti potpunost opreme kao i dokumentacije vozila. Vozilo osim oštećenja već navedenih na prvoj strani nema drugih oštećenja. Korisnik je detaljno upoznat sa načinom rukovanja opremom vozila.</p>
          </section>

          <section>
            <h3>2. Korištenje vozila</h3>
            <p>Zabranjeni su:</p>
            <ul>
              <li>davanje vozila na korištenje trećim osobama</li>
              <li>prepuštanje vozila trećim osobama,</li>
              <li>omogućavanje osobama koje nisu navedene u ovom Zapisniku da upravljaju vozilom (posebice predajom ključeva vozila),</li>
              <li>transport osoba,</li>
              <li>obuka vozača,</li>
              <li>vuča ili guranje drugih vozila,</li>
              <li>pušenje u vozilu,</li>
            </ul>
            <p>Korisnik smije vozilo koristiti samo dok ima za to valjanu vozačku dozvolu.</p>
            <p>Svojevoljno davanje na popravak od strane korisnika je nedozvoljeno. Kod vozila koja stoje moraju se ispravno osigurati odn. zaključati vrata i prozori. Dokumentacija vozila ne smije se ostavljati u nenadziranom vozilu. Upravljač mora biti zakočen.</p>
            <p>Radnje suprotne ovoj odredbi za posljedicu imaju gubitak pokrića osiguranja.</p>
          </section>

          <section>
            <h3>3. Vraćanje vozila</h3>
            <p>Korisnik je dužan vozilo vratiti u ispravnom stanju u dogovorenom roku na dogovorenom mjestu (u načelu Porsche Croatia, Zagreb - poseban dogovor sa rukovoditeljem marke moguć). Korisnik je obvezan vrijednost nevraćenih sastavnih dijelova, alata i sl. platiti pri vraćanju vozila. To vrijedi i za troškove ponovnog pribavljanja eventualno izgubljene dokumentacije vozila. Isključeno je jamstvo Porsche Croatia za predmete koje korisnik ostavi u vozilu.</p>
          </section>
        </div>

        <div class="col-12 col-md-6 grid-stack pickup-record-terms__column">
          <section>
            <h3>4. Osiguranje</h3>
            <p>Vozilo je kasko osigurano. Korisnik uzima na znanje da osim slučajeva navedenih u točki 2. ne postoji zaštita osiguranja niti ako se oštećenje prouzroči grubom nepažnjom ili namjerno, ili ako je do nezgode ili oštećenja vozila došlo zbog upravljanja vozilom pod utjecajem alkohola ili droga, kao i kod oštećenja, koja nastanu zbog tereta koji se eventualno prevozi.</p>
          </section>

          <section>
            <h3>5. Zaštita Porsche Croatia</h3>
            <p>Korisnik jamči za sve štete koje nastaju za vrijeme korištenja vozila na vozilu, kao i za štete koje on korištenjem vozila prouzroči trećim osobama. Korisnik se obvezuje, da će Porsche Croatia zaštititi glede odgovornosti za štetu ili tužbe zbog nedostataka koji iz toga nastanu.</p>
            <p>Korisnik posebice jamči i za:</p>
            <ul>
              <li>štete koje nastanu zbog neprimjerenog korištenja vozila,</li>
              <li>sve posljedice prekršaja zakonskih zabrana ili drugih nezakonitih radnji u zemlji i inozemstvu,</li>
              <li>naknadu šteta, za koje iz bilo kojih razloga nema jamstvenog pokrića,</li>
              <li>sve štete koje prouzroči treća osoba, kojoj je prepustio vozilo.</li>
            </ul>
          </section>

          <section>
            <h3>6. Ponašanje u slučaju prometne nezgode</h3>
            <p>Pri nastanku šteta ili pri sudjelovanju vozila u prometnoj nezgodi odmah telefonski treba informirati Porsche Croatia, Vozni park:</p>
            <p>tel. 01 6269 120, 6269 143<br>mob.: 099 801 4081</p>
            <p>Korisnik je obvezan u slučaju sudjelovanja u prometnoj nezgodi poduzeti sve što je za rješenje problema potrebno, posebice odmah obavijestiti policiju, utvrditi reg. oznake drugih vozila uključenih u prometnu nezgodu, utvrditi imena i adrese osoba-sudionika i svjedoka, popuniti europsko izvješće itd. Korisnik je obvezan Porsche Croatia i njegovom osiguratelju bez odlaganja, u svakom slučaju odmah po upitu dati sve informacije koje zatraže. Korisnik nema pravo priznavati ili djelomično priznati niti isplaćivati zahtjeve trećih osoba.</p>
          </section>
        </div>
      </div>
    </article>
  </section>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import AppPageTitleBar from '../../components/AppPageTitleBar.vue'

const route = useRoute()
const router = useRouter()
const returnRoute = computed(() => {
  const path = route.query.returnTo
  if (typeof path === 'string') {
    const resolved = router.resolve(path)
    if (['fleet-record-pickup-create', 'fleet-record-pickup-form', 'fleet-record-return-form', 'fleet-record-pickup-view', 'fleet-record-return-view'].includes(resolved.name)) {
      return path
    }
  }

  return { name: 'fleet-forms' }
})
</script>

<style scoped lang="scss">
.pickup-record-terms {
  &__document {
    color: var(--color-text-muted);
    line-height: 1.5;
  }

  &__title {
    margin: 0 0 40px;
    color: inherit;
    font-size: 20px;
    line-height: 1.4;
  }

  &__column {
    align-content: start;
    row-gap: 40px;

    h3 {
      margin: 0 0 16px;
      color: inherit;
      font-size: 16px;
      line-height: 1.5;
    }

    p,
    ul {
      margin: 0 0 16px;
    }

    p {
      text-align: justify;
    }

    section > :last-child {
      margin-bottom: 0;
    }

    ul {
      padding: 0;
      list-style: none;
    }

    li + li {
      margin-top: 12px;
    }

    li::before {
      content: '- ';
    }
  }

  @include breakpoint-up('sm') {
    &__document {
      padding: clamp-bp('sm', 'xl', 32, 56) clamp-bp('sm', 'xl', 64, 112);
    }

    &__title {
      margin-bottom: 64px;
    }
  }

  @include breakpoint-up('md') {
    &__columns {
      column-gap: clamp-bp('md', 'xl', 40, 64);
    }

    &__column {
      row-gap: 72px;
    }
  }
}
</style>
